import idx from 'idx';
import * as React from 'react';
import Modal from 'react-modal';
import once from 'lodash/once';
import { isEmpty } from 'lodash';
import Message from 'entities/Message';
import Link from 'components/Link';
import events from '../constants/events';
import Button from 'components/ButtonDeprecated';
import Dialog from 'components/Dialog';
import BoxBody from 'components/BoxBody';
import Buttons from 'components/Buttons';
import Timestamp from 'components/Timestamp';
import ShareSDKHeader from './ShareSDKHeader';
import SplitComposerDataContainer from './ShareSDKSplitComposer/ShareSDKSplitComposerDataContainer';
import { isWithinIframe } from './ShareSDKUtility';

import Row from 'components/Row';
import Box from 'components/Box';

// $FlowFixMe
import './styles/ShareSDKComposer.scss';

type HandleMessageSentOptions = {
  scheduledTime?: Date;
};

type ConfirmationModalOptions = {
  scheduledTime?: Date;
};

type State = {
  confirmationModalOptions: ConfirmationModalOptions | undefined | null;
};

type ConfirmationDialogProps = {
  scheduledTime: Date | undefined | null;
  onRequestHide: Function;
};

const ConfirmationDialog = (props: ConfirmationDialogProps) => {
  const { scheduledTime } = props;

  let title: string | React.ReactNode = 'Your message was sent';
  let subtext: string | React.ReactNode = '';

  if (scheduledTime) {
    title = (
      <span>
        Your message was scheduled for <Timestamp format="long" date={scheduledTime} /> at{' '}
        <Timestamp format="time" date={scheduledTime} />!
      </span>
    );

    subtext = (
      <span>
        You can go to Remind to edit and manage your scheduled messages before they go out.
      </span>
    );
  }

  return (
    // @ts-expect-error
    <Dialog size="small" title={title} subtext={subtext} onRequestHide={props.onRequestHide}>
      <BoxBody>
        <Buttons full axis="x">
          {!!scheduledTime && (
            <Link href="https://www.remind.com" target="_blank">
              {/* @ts-expect-error */}
              <Button level="secondary" onClick={props.onRequestHide}>
                Go to Remind
              </Button>
            </Link>
          )}
          {/* @ts-expect-error */}
          <Button onClick={props.onRequestHide}>Done</Button>
        </Buttons>
      </BoxBody>
    </Dialog>
  );
};

type Props = {
  location: {
    query: {
      url: string;
      message: string;
    };
  };
};

class ShareSDKComposer extends React.Component<Props, State> {
  state = {
    confirmationModalOptions: null,
  };

  close = () => this.setState({ confirmationModalOptions: null });

  handleMessageSent = (options: HandleMessageSentOptions = {}) => {
    if (window.parent) {
      window.parent.postMessage(events.MESSAGE_SENT, '*');
    }

    this.setState({
      confirmationModalOptions: {
        scheduledTime: options.scheduledTime,
      },
    });
  };

  getInitialMessageFromQueryParams = once(() => {
    const message = idx(this.props, (_) => _.location.query.message);
    const url = idx(this.props, (_) => _.location.query.url);
    const combinedMessage = [message, url].filter((s) => isEmpty(s) === false).join(' ');
    return message || url ? new Message({ body: combinedMessage }) : undefined;
  });

  render() {
    const { confirmationModalOptions } = this.state;

    const isOpen = !!confirmationModalOptions;
    // @ts-expect-error
    const scheduledTime = confirmationModalOptions && confirmationModalOptions.scheduledTime;
    const modal = (
      <ConfirmationDialog
        scheduledTime={scheduledTime}
        onRequestHide={() => {
          // if we are a popup window then close the window on message send.
          if (isWithinIframe() === false) {
            window.close();
          } else {
            this.close();
          }
        }}
      />
    );
    const message = this.getInitialMessageFromQueryParams();
    const shareSdkBodyUrl = idx(this.props, (_) => _.location.query.url) as string | undefined;

    // we unmount the composer when the modal is open
    // because the split composer is broken and doesn't handle
    // not being unmounted after sending a message (the loaded recipients will all disapear)

    return (
      <div className="ShareSDKComposer">
        <Row size="xxxlarge">
          <ShareSDKHeader />
        </Row>
        <Box size="large">
          <Modal isOpen={isOpen}>{modal}</Modal>
          {!isOpen && (
            <SplitComposerDataContainer
              data-test-selector="composer"
              draftAnnouncement={message}
              onMessageSent={this.handleMessageSent}
              shareSdkBodyUrl={shareSdkBodyUrl}
              skipSelectRecipients
              messageType="message"
            />
          )}
        </Box>
      </div>
    );
  }
}

export default ShareSDKComposer;
